<template>
  <div class="goods">
    <Fontnavbar title="商品详情" />
    <!-- <backTop/> -->
    <van-button class="back" size="small" round icon="arrow-up" @click="goTop">顶部</van-button>
    <div class="goods-tab" :class="{ fixed: isFixed }" id="searchBar">
      <van-icon name="arrow-left" @click="comeBack" class="top-btn" />
      <div :class="tabIndex == 'content-1' ? 'goods-tab-item on' : 'goods-tab-item'" class="goods-tab-item" @click="changeTab('content-1')">
        商品
      </div>
      <div :class="tabIndex == 'content-2' ? 'goods-tab-item on' : 'goods-tab-item'" class="goods-tab-item" @click="changeTab('content-2')">
        详情
      </div>
      <div :class="tabIndex == 'content-3' ? 'goods-tab-item on' : 'goods-tab-item'" class="goods-tab-item" @click="changeTab('content-3')">
        微信素材
      </div>
      <van-icon name="manager" @click="goUserCenter" class="top-btn" />
    </div>

    <van-swipe id="content-1" class="goods-swipe"  indicator-color="#ff0000">
      <van-swipe-item v-if="goods.goods_video">
        <video-player  class="video-player vjs-custom-skin"
                       ref="videoPlayer"
                       :playsinline="true"
                       :options="playerOptions"
        ></video-player>
      </van-swipe-item>
      <van-swipe-item v-for="(item, i) in goods.goods_gallery" :key="i">
        <img :src="imgDomain + item.origin_path" />
      </van-swipe-item>
    </van-swipe>

    <!--    限时特价导航栏 开始 -->
    <div v-if="goods.promotion_info && goods.promotion_info.start_time > goods.promotion_info.now" class="xstj-start">
      <div class="left">
        <div class="promotion-price">￥{{ goods.promotion_info.promotion_price }}</div>
        <div class="promotion-font">限时特价即将开售</div>
      </div>
      <div class="right">
        <div>{{goods.promotion_info.start_date}}开抢</div>
      </div>
    </div>

    <div v-if="goods.promotion_info && goods.promotion_info.start_time < goods.promotion_info.now" class="xstj-end">
      <div class="left">
        <div class="promotion-price">￥{{ goods.promotion_info.promotion_price }}</div>
        <div class="promotion-font">{{goods.promotion_info.activity_name}}</div>
      </div>
      <div class="right">
        <div>距结束还剩</div>
        <van-count-down class="count-down" :time="(goods.promotion_info.end_time - goods.promotion_info.now) * 1000" format="DD天HH:mm:ss" />
      </div>
    </div>
    <!--    限时特价导航栏 结束 -->

    <van-cell-group>
      <van-cell>
        <div class="goods-title">{{ goods.goods_name }}</div>
        <div class="goods-price" style="display: flex; justify-content: space-between">
          <div style="display: flex">
            <img :src="'/static/special_offer.png'" v-if="goods.price_type !=='user_price'" />
            <div>￥{{ goods.goods_price }}</div>
          </div>
          <div class="small-gray del-line" v-if="goods.price_type !=='user_price'">原价：{{ goods.user_price }}</div>
          <div class="small-gray">销量：{{ goods.sale_num }}</div>
        </div>
      </van-cell>
      <van-cell class="goods-express">
        <div class="goods-step" v-for="(item, i) in goods.goods_step" :key="i">
          <div>数量≥{{ item.step_num }} 单价：￥{{ item.step_price }}</div>
        </div>
        <div style="display: flex">
          <van-stepper v-model="goods_num" @change="changeNum" :max="goods.goods_fact_stock + goods.goods_stock" />
          <div>(可购{{ goods.goods_fact_stock + goods.goods_stock}}件)</div>
        </div>


        <!-- <van-stepper v-model="item.goods_num" @change="changeNum" :name="i" :max="goods.goods_fact_stock" /> -->
        <div class="open_vip">
          <div class="vip_text">
            <div class="vip_price">
              <span class="text">VIP价格</span>
              <div class="price">￥<span>{{goods.vip_price}}</span></div>
            </div>
            <div class="content">
              开通VIP可享全网2000余件商品VIP价格
            </div>
          </div>
          <div class="to_open" @click="openVip">
            {{ goods.is_vip? '立即续费': '立即开通' }}
          </div>
        </div>
      </van-cell>
    </van-cell-group>

    <!-- 正品保障 -->
    <van-cell-group class="goods-cell-group">
      <van-cell>
        <div class="goods_quality">
          <img :src="'/static/quality_goods.png'" alt="">
          个秀保障
        </div>
        <div class="quality_info">100%正品保障 • 7天无理由退货（拆封后不支持）</div>
      </van-cell>
    </van-cell-group>

<!--    相关商品推荐-->
    <van-cell-group class="goods-cell-group">
      <van-cell title="相关商品推荐"/>
      <van-cell>
        <div class="home-goods-3">
          <div class="home-goods-3-item" v-for="(v,k) in recommend" :key="k">
            <div v-if="k<6">
              <div class="goods" @click="getList(v.id)">
                <div class="goods-img">
                  <van-image width="100%" height="100%" :src="imgDomain + v.goods_thumb_path" />
                </div>
                <div class="goods-title">{{ v.goods_name }}</div>
                <van-row type="flex" justify="space-between">
                  <van-col span="18">
                    <div class="goods-price">￥{{ v.goods_price }}</div>
                  </van-col>
                  <van-col span="6">
                    <div class="cart-btn" @click.stop="addCart(v.id)">
                      <div class="cart-btn-item">
                        <van-icon name="shopping-cart-o" />
                      </div>
                    </div>
                  </van-col>
                </van-row>
              </div>
            </div>

          </div>
        </div>
      </van-cell>
    </van-cell-group>


    <van-cell-group class="goods-cell-group" id="content-2">
      <van-cell title="商品详情" @click="sorry" />
      <van-cell>
        <div>商品名称: {{ goods.goods_name }}</div>
        <div v-for="(item, i) in goods.base_attr_list" :key="i">
          <div v-if="item.attr_value">{{ item.attr_name }}: {{ item.attr_value }}</div>
        </div>
        <div v-html="goods.content_no_distribute">
          {{ goods.content_no_distribute }}
        </div>
        <div v-html="goods.goods_brief" style="overflow: auto" id="content">
          {{ goods.goods_brief }}
        </div>
        <div v-html="goods.goods_content">
          {{ goods.goods_content }}
        </div>
        
      </van-cell>
    </van-cell-group>

    <van-cell-group class="goods-cell-group" id="content-3">
      <van-cell title="微信素材" @click="sorry" />
      <van-cell>
        <div class="dynamic">
          <div class="dynamic-item" v-for="(item, i) in goods.dynamic" :key="i">
            <div class="dynamic-item-title" @click="goDynamicPage('/dynamic/detail?goods=' + item.id)">{{ item.content }}</div>
            <div class="dynamic-item-img">
              <div class="dynamic-item-img-box" v-for="(v, k) in item.gallary_array" :key="k">
                <!-- <img :src="imgDomain + v"> -->
                <van-image width="100" height="100" :src="imgDomain + v" @click="show_img(item.gallary_array, k)" />
              </div>
            </div>
          </div>
        </div>
      </van-cell>
    </van-cell-group>

    <van-goods-action>
      <van-goods-action-icon icon="home-o" @click="goPage('/')">
        首页
      </van-goods-action-icon>
      <van-goods-action-icon icon="cart-o" @click="goPage('/cart/index')">
        购物车
      </van-goods-action-icon>
      <van-goods-action-icon icon="chat-o" @click="goPages('/service/index')">
        客服
      </van-goods-action-icon>
      <van-goods-action-icon icon="like-o" @click="like" v-if="this.item_like == false">
        收藏
      </van-goods-action-icon>
      <van-goods-action-icon icon="like" color="red" @click="like" v-else>
        收藏
      </van-goods-action-icon>
      <van-goods-action-button type="warning" @click="addCart(goods.id)">
        加入购物车
      </van-goods-action-button>
      <!-- <van-goods-action-button type="danger" @click="sorry">
        立即购买
      </van-goods-action-button> -->
    </van-goods-action>

    <div class="g-loading" v-if="loading">
      <van-loading type="spinner" />
    </div>
  </div>
</template>

<script>
  import {
    Loading,
    Tag,
    Col,
    Icon,
    Cell,
    CellGroup,
    Swipe,
    Toast,
    SwipeItem,
    Stepper,
    GoodsAction,
    GoodsActionIcon,
    GoodsActionButton,
    Image,
    ImagePreview,
    Row,
    Dialog,
    CountDown,
    Button
  } from 'vant'
import Fontnavbar from '../../components/Navbar.vue'
// import backTop from "../../components/backTop.vue";
import { getGoodsDetail, addCart, collect, getUserInfo, getPromotionList } from '../../api.js'
import { post } from '../../request.js'
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
export default {
  components: {
    [Loading.name]: Loading,
    [Image.name]: Image,
    [Tag.name]: Tag,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Row.name]: Row,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Swipe.name]: Swipe,
    [Stepper.name]: Stepper,
    [SwipeItem.name]: SwipeItem,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton,
    [CountDown.name]: CountDown,
    Fontnavbar,
    videoPlayer,
  },

  data() {
    return {
      loading: false,
      imgDomain: process.env.VUE_APP_IMG_URL,
      goods: [],
      tabIndex: 'content-1',
      item_like: '',
      goodsId: '',
      isFixed: false,
      goods_num: 1,
      recommend:[],
      video: {
        options:{
          // autoplay
          autoplay: true,
          // default volume
          volume: 0.6,
          // poster (cover image)
          poster: 'http://covteam.u.qiniudn.com/poster.png'
        }
      }
    }
  },

  computed: {
    playerOptions(){
      return {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          src: this.imgDomain + this.goods.goods_video,  // 路径
          type: 'video/mp4'  // 类型
        }],
        poster: this.imgDomain + this.goods.goods_video + "?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast,ar_auto", //你的封面地址
        // poster: "../../static/images/test.jpg", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true  //全屏按钮
        }
      }
    }
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.getList(this.$route.query.id);
    this.getRecommendList();
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    //跳转顶部,吸顶
    handleScroll() {
      const that = this
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      that.scrollTop = scrollTop

      var offsetTop = document.querySelector('#searchBar').offsetTop
      // console.log(scrollTop,offsetTop)
      if (scrollTop > offsetTop) {
        that.isFixed = true
      } else {
        that.isFixed = false
      }
      if (scrollTop == 0) {
        that.isFixed = false
      }
    },
    //查看大图
    show_img(img_arr, k) {
      var imgArr = []
      for (var j = 0; j < img_arr.length; j++) {
        imgArr.push(this.imgDomain + img_arr[j])
      }
      ImagePreview({
        images: imgArr,
        startPosition: k,
        closeable: true,
      })
    },
    // 返回上一页
    comeBack(){
      this.$router.back();
    },
    // 去用户中心
    goUserCenter(){
      this.$router.push({ path: '/user/index' })
    },
    goDynamicPage(path) {
      this.$router.push({ path: path })
      if (window.dynamic) {
        window.dynamic.goPage(path)
      }
    },
    goTop() {
      // window.scroll(0,0);
      const that = this
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 10)
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 10)
    },
    //收藏
    like() {
      post(getUserInfo, {}).then((res) => {
        if (res.code == 200) {
          // 用户信息

          this.item_like = !this.item_like
          var that = this
          var postData = {
            goods_id: that.goodsId,
          }
          post(collect, postData).then((res) => {
            if (res.code == 200) {
              // 用户信息
            } else {
              this.$message({
                message: res.msg,
                type: 'warning',
              })
            }
          })
        } else if (res.code == 201) {
          Dialog({ message: '您当前未登录' })
          setTimeout(() => {
            this.$router.replace({ path: '/user/login' })
          }, 1000)
        }
      })
    },
    formatPrice() {
      return '¥' + (this.goods.price / 100).toFixed(2)
    },

    // 开通会员
    openVip(){
      if(!this.goods.is_login){
        Dialog({ message: '您当前未登录' })
          setTimeout(() => {
            this.$router.replace({ path: '/user/login' })
          }, 1000)
      }else{
        this.$router.push({ path: '/goods/member' })
      }
    },

    goPage(path) {
      this.$router.push({ path: path })
      // console.log(this.$router.meta.title);
    },
    goPages(path) {
      var that = this
      post(getUserInfo, {}).then((res) => {
        if (res.code == 200) {
          // 用户信息
          that.$router.push({ path: path })
        } else if (res.code == 201) {
          Dialog({ message: '您当前未登录' })
          setTimeout(() => {
            this.$router.replace({ path: '/user/login' })
          }, 1000)
        }
      })

      // console.log(this.$router.meta.title);
    },
    //
    sorry() { },
    changeTab(tabIndex) {
      this.tabIndex = tabIndex
      // 获取点击的按钮对应页面的id
      var pageId = document.querySelector('#' + tabIndex)
      window.scrollTo({
        top: pageId.offsetTop,
        behavior: 'smooth',
      })
    },

    addCart(goods_id) {
      this.loading = true
      post(getUserInfo, {}).then((res) => {
        if (res.code == 200) {
          // 用户信息
          post(addCart, { goods_id: goods_id, goods_num: this.goods_num }).then(
            (res) => {
              this.loading = false
              if (res.code == 200) {
                Toast.success('加入成功')
              } else {
                Toast(res.msg)
              }
            }
          )
        } else if (res.code == 201) {
          Dialog({ message: '您当前未登录' })
          setTimeout(() => {
            this.$router.replace({ path: '/user/login' })
          }, 1000)
        }
      })
    },
    // 改变数量
    changeNum(goods_num, detail) {
      // console.log(this.goods_num);
      console.log(detail, goods_num)
    },
    // 获取初始化列表
    getList(goods_id){
      var loading = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0,
      })
      post(getGoodsDetail, { id: goods_id }).then((res) => {
        if (res.code == 200) {
          this.goods = res.data
          // console.log("this.goods: ", this.goods);
          this.item_like = res.data.collect_status
          window.scrollTo(0,0);
          // document.documentElement.scrollTop = 0;
        } else {
          Toast('网络错误')
        }
        loading.clear()
      })
    },
    // 获取推荐列表
    getRecommendList() {
      var that = this
      var postData = {
        id: 6
      }
      post(getPromotionList, postData).then((res) => {
        if (res.code == 200) {
          that.recommend = res.data.goods_list.slice(0, 6)
        } else {
          Toast('网络错误');
        }
      })
    },
  },
}
</script>

<style lang="less">
// 潔 start
.open_vip{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  margin: 20px 0 10px;
  color: #ffffff;
  border-radius: 12px;
  height: 72px;
  background: linear-gradient(to right, #2f3140, #686974);
  .vip_text{

    .vip_price{
      display: flex;
      font-size: 14px;
      .price{
        margin-left: 10px;
        span{
          font-size: 18px;
        }
      }
    }
    .content{
      opacity: .6;
    }
  }
  .to_open{
    padding: 0 10px;
    line-height: 28px;
    font-size: 14px;
    color: #333333;
    border-radius: 14px;
    background-color: #fff0d4;
  }
}

// 潔 end

  .small-gray{
    color: grey;
    font-size: 12px;
  }
  .del-line{
    text-decoration:line-through;
  }
.goods {
  padding-bottom: 50px;

  &-swipe {
    padding-top: 3px;
    background-color: #ffffff;
    img {
      width: 100%;
      display: block;
    }
  }

  &-title {
    font-size: 16px;
  }

  &-price {
    font-weight: 800;
    color: #f44;
    font-size: 24px;
    margin-top: 10px;
  }

  &-step {
    color: #f44;
    font-size: 14px;
    margin-top: 10px;
  }
  &-express {
    color: #999;
    font-size: 12px;
    padding: 5px 15px;
  }

  &-cell-group {
    margin: 15px 0;
    .van-cell__value {
      color: #999;
    }
  }

  &-tag {
    margin-left: 5px;
  }
  .goods-price{
    display: flex;
    align-items: center;
    img{
      width: 33px;
      height: 27px;
    }
  }
  .goods_quality{
    display: flex;
    padding: 4px 0 2px;
    align-items: center;  
    font-size: 16px;
    color: #F0A753;
    font-weight: 600;
    img{
      width: 19px;
      height: 19px;
      margin-right: 6px;
    }
  }
  .quality_info{
    font-size: 12px;
    color: #383839;
  }
}
.goods-tab {
  width: 100%;
  display: block;
  background-color: #ffffff;
  font-size: 16px;
  color: #333333;
  line-height: 40px;
  // position: fixed;
  top: 40px;
  left: 0px;
  z-index: 9999;
}

.fixed {
  position: fixed;
  margin-top: -11%;
}

.goods-tab .on {
  color: #ff0000;
  border-bottom: 2px solid #ff0000;
}
.goods-tab-item {
  width: 28%;
  display: inline-block;
  text-align: center;
}

.dynamic-item {
  padding-bottom: 15px;
  border-bottom: 1px solid #dddddd;
}
.dynamic-item:last-child {
  border-bottom: 0px solid #dddddd;
}
.dynamic-item-title {
  font-size: 14px;
  color: #666666;
  margin-bottom: 5px;
}
.dynamic-item-img {
  display: flex;
  flex-wrap: wrap;
}
.dynamic-item-img-box {
  // float: left;
  width: 100px;
  height: 100px;
  // overflow: hidden;
  margin-right: 5px;
  margin-bottom: 5px;
}
// .dynamic-item-img-box img{
// 	object-fit: cover;
// 	width: 100%;
// 	height: 100%;
// }
img {
  width: 100%;
  height: 100%;
}
.back {
  position: fixed;
  bottom: 80px;
  margin-left: 80%;
  z-index: 99999999999;
}

.home {
  padding-bottom: 50px;
  &-goods-3 {
    display: inline-block;
    background-color: #ffffff;
  }
  &-goods-3-item {
    width: 33.3333%;
    display: inline-block;

    .goods {
      padding: 10px 10px 0;
    }
    .goods-img {
      vertical-align: middle;
    }
    .goods-title {
      margin-top: 8px;
      font-size: 12px;
      line-height: 20px;
      color: #666666;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .goods-price {
      height: 40px;
      font-size: 14px;
      line-height: 40px;
      color: #f00;
    }
    .cart-btn {
      height: 50px;
      line-height: 50px;
      text-align: right;
    }
    .cart-btn-item {
      vertical-align: middle;
      display: inline-block;
      text-align: center;
      width: 24px;
      line-height: 22px;
      color: #ffffff;
      padding-top: 2px;
      font-size: 16px;
      margin-top: 6px;
      border-radius: 12px;
      background-color: #ff0000;
    }
    .top-btn{
      font-size: 20px;
      line-height: 40px;
    }
  }

}

.xstj-start{
  width: 100%;
  height: 60px;
  color: white;
  background: #F62C38;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left{
    margin-left: 20px;
    .promotion-price{
      font-size: 22px;
    }
    .promotion-font{
      margin-left: 5px;
      font-size: 12px;
    }
  }
  .right{
    margin-right: 20px;
    .count-down{
      color: white;
      font-weight: bolder;
    }
  }
}

  .xstj-end{
    width: 100%;
    height: 60px;
    color: white;
    background: #F62C38;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left{
      margin-left: 20px;
      .promotion-price{
        font-size: 22px;
      }
      .promotion-font{
        margin-left: 5px;
        font-size: 12px;
      }
    }
    .right{
      margin-right: 20px;
      .count-down{
        color: white;
        font-weight: bolder;
      }
    }
  }

</style>
